import axios from 'axios';
import * as Sentry from '@sentry/react';

export const config = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        Sentry.captureMessage('User triggered 401');
      }

      // Reject promise to trigger error handling
      return Promise.reject(error);
    },
  );
};
